import React from "react"
import { FleContinueWrapper, FleLayout } from "../FleLayout"
import { ContinueArrow, LeftArrow, Skip, SwitchH2ToBodyLarge } from "../Molecules"
import { Spacer } from "../../atoms/Atoms"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { Form } from "components/views/atoms/forms/Form"
import { TopSection } from "../TopSection"
import { BodySmall } from "../../atoms/Bodies"
import L10n from "../../../../lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

interface PreferredNameProps {
  preferredName?: string
  setPreferredName: (newValue: string) => void
  onBack: () => void
  onComplete: () => void
}
export function PreferredName({
  preferredName,
  setPreferredName,
  onBack,
  onComplete
}: PreferredNameProps): JSX.Element {
  function handleSkip(): void {
    setPreferredName(null)
    onComplete()
  }

  return (
    <FleLayout
      bottomContent={
        <FleContinueWrapper>
          <Skip onClick={handleSkip} onClickOnly />
          <ContinueArrow onClick={onComplete} />
        </FleContinueWrapper>
      }
    >
      <Form onSubmit={onComplete}>
        <TopSection showProgressTracker={false} progressStep={1} leftOrBackArrow={<LeftArrow onClick={onBack} />} />
        <SwitchH2ToBodyLarge>{l`fle2.aboutyou.preferredName.title`}</SwitchH2ToBodyLarge>
        <Spacer height={1} />
        <BodySmall color="black-80">{l`fle2.aboutyou.preferredName.body`}</BodySmall>
        <Spacer height={2} />
        <CompleteFormInput
          name={"preferredName"}
          label={"Name"}
          value={preferredName}
          onChange={(e) => setPreferredName(e.target.value)}
        />
      </Form>
    </FleLayout>
  )
}
